<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive, nextTick } from "vue";
import { goBack } from "@/NavigationHelper";
import { Globals } from "@/Globals";
import { getKennungValueDisplay } from "@/DataHelper";
import { globalsBezeichnung, checkBegriff } from "@/local";
import CommonBaseButtons from "@/components/common/BaseButtons.vue";
import { mountedBase, BaseSetup, onSave } from "@/DataLoaderStatic";
import {
  createEditorValidator,
  provideEditorValidator,
} from "@/components/EditorValidator";
import { showSnackbar } from "@/UIHelper";
const validator = createEditorValidator();
provideEditorValidator(validator);

const emit = defineEmits(["back", "save"]);
let zeitbereichUebergabe!: APIZeitbereich | null;
let dateMitarbeiter = ref<Date | null>(null);
let dateVorgesetzter = ref<Date | null>(null);
let textVorgesetzter = ref<string>("");
let iconAmpel = ref<string>("");

const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "WEB_ErfassungMemo_Freigabe",
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  if (zeitbereichUebergabe) {
    uiData.zeitbereich = zeitbereichUebergabe;
  }
  await mountedBase(uiData, pageParams);
  if (!uiData.showLoading && uiData.data) {
    dateMitarbeiter.value = getKennungValueDisplay(
      uiData.data[0],
      "ZE_FREIGABE_MA",
      uiData.columns
    );
    dateVorgesetzter.value = getKennungValueDisplay(
      uiData.data[0],
      "ZE_FREIGABE_ABLEHNUN",
      uiData.columns
    );

    textVorgesetzter.value = getKennungValueDisplay(
      uiData.data[0],
      "MEMO_VORGESETZTER",
      uiData.columns
    );
    iconAmpel.value = getKennungValueDisplay(
      uiData.data[0],
      "ampel",
      uiData.columns
    );
  }
  uiData.showLoading = false;
  uiData.initialized = true;
});
async function onValidate() {
  return await validator.validateAsync();
}
async function save() {
  const isvalid = await onValidate();
  if (!isvalid.valid) {
    showSnackbar({
      text:
        "Validierung fehlgeschlagen - Bitte prüfen! (" +
        isvalid.invalidFields.join(", ") +
        ")",
      duration: 4000,
      color: "error",
    });
    return;
  }
  onSave(uiData, pageParams).then(() => {
    nextTick(() => emit("save"));
  });
}
</script>

<template>
  <v-sheet class="pa-0 w-100" style="width: 100%">
    <v-progress-linear
      :indeterminate="true"
      v-if="uiData.showLoading"
      color="dvhSlider"
    ></v-progress-linear>
    <v-expansion-panels
      class="pa-0 w-100 wf-expansion"
      style="width: 100%"
      rounded="0"
      v-if="checkBegriff('ZE_Mitarbeiter_Monatsabschluss')"
    >
      <v-expansion-panel v-if="uiData.initialized">
        <v-expansion-panel-title
          disable-icon-rotate
          class="subtitle-1 lighten-2 white--text dvhBackground"
        >
          <span style="color: white">{{ uiData.header.bezeichnung }}</span>
          <!-- <v-img v-if="iconAmpel" v-html="iconAmpel"></v-img> -->
          <template v-slot:actions>
            <v-icon color="white">$expand</v-icon>
          </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text class="pa-0">
          <div>
            {{
              globalsBezeichnung(
                Globals.Begriff,
                "Web_Freigabe_MA",
                "Freigabe Mitarbeiter"
              )
            }}: {{ dateMitarbeiter }}
          </div>

          <div>
            {{
              globalsBezeichnung(
                Globals.Begriff,
                "Web_Freigabe_VG",
                "Freigabe Vorgesetzter"
              )
            }}: {{ dateVorgesetzter }}
          </div>

          <!-- <div>
          {{
            globalsBezeichnung(
              Globals.Begriff,
              "Web_Memo_VG",
              "Memo Vorgesetzter"
            )
          }}:
        </div> -->
          <!-- 
        <div class="pb-2">{{ textVorgesetzter }}</div> -->
          <EditTextArea
            kennung="MEMO_VORGESETZTER"
            description="Memo Vorgesetzter"
            :disabled="true"
            :readonly="true"
            class="pt-2"
          />

          <EditTextArea
            v-if="!dateVorgesetzter"
            kennung="MEMO_MITARBEITER"
            description="Memo Mitarbeiter"
          />
          <EditTextArea
            v-if="dateVorgesetzter"
            kennung="MEMO_MITARBEITER"
            description="Memo Mitarbeiter"
            :disabled="true"
            :readonly="true"
            class="pt-2"
          />

          <v-spacer></v-spacer>
          <CommonBaseButtons
            v-if="!dateVorgesetzter && dateMitarbeiter"
            :backVisible="false"
            :deleteVisible="false"
            :createVisible="false"
            :refreshVisible="false"
            :saveVisible="true"
            @back="goBack()"
            @save="save"
          ></CommonBaseButtons>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-sheet>
</template>

<style scoped>
.v-expansion-panel-text > * {
  margin: 0;
  padding: 5px;
}
</style>
